import { hkdf } from "@noble/hashes/hkdf.js";
import { sha256 } from "@noble/hashes/sha256.js";

export function deriveKey(
  ikm: Uint8Array,
  salt: Uint8Array | string,
  info: string,
  length = 32,
): Uint8Array {
  const saltBytes =
    typeof salt === "string" ? new TextEncoder().encode(salt) : salt;
  return hkdf(sha256, ikm, saltBytes, info, length);
}
